import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function OpacityIcon(props: IconProps) {
    return <Icon {...props} iconKey={"opacity"}/>
}
